import { screensInt } from '../styles/constants';

const windowSize = {
  xsSize() {
    return window.innerWidth <= 420;
  },
  smallSize() {
    return window.innerWidth <= screensInt.md;
  },
};

export default windowSize;
